export const logoTypes = {
    MODULE_LOGO_SUCCESS: 'MODULE_LOGO_SUCCESS',
    MODULE_LOGO_FAILURE: 'MODULE_LOGO_FAILURE',
}
